<div class="avs-route-station-container position-relative">
    <div class="avs-route-station-header">
        <avs-station-meta-info class="d-flex justify-content-center"
            [metaInformation]="metaInformation"
            [x]="stationX" [y]="stationY"
            layout="stacked"></avs-station-meta-info>
        <div class="d-flex justify-content-center">
            <span class="avs-route-station-label m-1 ps-2 pe-2">{{stationName}}</span>
        </div>
        <div class="d-flex justify-content-center">
            <span class="m-1 text-secondary">SAM ID: {{stationSamId}}</span>
        </div>
        <span class="text-secondary d-flex justify-content-center " *ngIf="!isOnline">
        </span>
    </div>
    <div class="d-flex">
        <div class="avs-route-station-site-area"
            [ngClass]="ledChannelError ? 'extra-margin' : ''">
            <ng-container *ngIf="isOnline">

                <!-- Unique abhängigkeiten?
werden ja im späteren verlauf als mQ erkannt, hier bräuchte ich mal reine aufbauten, damit ich das ordentlich machen kann, ansonsten muss der rest ja auch enstprechend geändert werden 

ggf. eine weitere gruppenType? 

temporär selber setzen? wenn cams vorhanden ist?



cam 19 ist dome
cam 18 ist kfz


-->


                <ng-container
                    *ngIf="(deviceType === DeviceTypeEnum.AQ || deviceType === DeviceTypeEnum.Mixed) && !isPW">
                    <div class="d-flex justify-content-center">
                        <img height="36" alt="Icon for LED Brightness" src="assets/icons/brightness-alt-high.svg"
                            [ngClass]="ledChannelError ? 'led-error-small' : ''">
                    </div>
                    <div [ngClass]="isOnline ? '' : 'text-secondary'"
                        class="text-center small d-flex justify-content-center" style="margin-top: -10px;"
                        [ngClass]="ledChannelError ? 'd-none' : ''">
                        <span *ngIf="ledLinkedMode">
                            <img src="assets/icons/link_material.svg"/>
                        </span>
                        <span>{{ledBrightness}}</span>

                    </div>

                </ng-container>
                <div [ngClass]="solarChannelError ? 'led-error-small' : ''">
                    <div class="d-flex justify-content-center"
                        [class]="deviceType === DeviceTypeEnum.MQ || isPW ? 'mt-4' : ''">
                        <img *ngIf="isModalOpen" height="36" alt="Batterie Icon nach Akku Spannung"
                            [src]="getBatteryIcon()"
                            matTooltip=" {{ solarDateTime | date: 'dd.MM.yyyy H:mm'}}"
                            (click)="openVoltageChart()" class="icon-button">
                        <img *ngIf="!isModalOpen" height="36" alt="Batterie Icon nach Akku Spannung"
                            [src]="getBatteryIcon()"
                            matTooltip=" {{ solarDateTime | date: 'dd.MM.yyyy H:mm'}}">
                    </div>
                    <div [ngClass]="isOnline ? '' : 'text-secondary'"
                        class="text-center small" style="margin-top: -10px;">
                        {{batteryVoltageText}}
                    </div>
                    <div>
                        <div class="d-flex justify-content-center">
                            <div class="position-relative">
                                <img height="36" alt="Batterie Icon Ladestrom"
                                    src="assets/icons/battery/battery_very_low_FILL0_wght400_GRAD0_opsz24.svg">
                                <img class="position-absolute avs-route-station-arrow-battery" height="20"
                                    alt="Pfeil rechts -> batterie laden"
                                    [src]="powerPurchaseIcon">
                            </div>
                        </div>
                        <div [class]="batteryCurrentClass"
                            style="margin-top: -10px;">
                            {{batteryCurrentText}}
                        </div>
                    </div>
                    <div>
                        <div class="d-flex justify-content-center">
                            <div class="position-relative">
                                <img *ngIf="isModalOpen" height="20" alt="Stromverbrauch Icon"
                                    src="../../../assets/icons/stromverbrauch_blitz_pfeil.svg"
                                    (click)="openCurrentChart()" class="icon-button">
                                <img *ngIf="!isModalOpen" height="20" alt="Stromverbrauch Icon"
                                    src="../../../assets/icons/stromverbrauch_blitz_pfeil.svg">
                            </div>
                        </div>
                        <div class="text-center small text-danger" style="margin-top: -3px;">

                            {{loadCurrentText}}
                        </div>
                    </div>
                    <div *ngIf="isModalOpen">
                        <div class="d-flex justify-content-center mt-1">
                            <div *ngFor="let cInfo of solarPanelCInfos">
                                <div *ngIf="cInfo.channel.de === 11"
                                    style="width: 15px; "
                                    [ngClass]="cInfo.channel.isInChannelError ? 'channel-error' : 'no-channel-error'"
                                    class="m-1 text-center">1</div>
                                <div *ngIf="cInfo.channel.de === 12"
                                    style="width: 15px;"
                                    [ngClass]="cInfo.channel.isInChannelError ? 'channel-error' : 'no-channel-error'"
                                    class="m-1 text-center">2</div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div *ngIf="!isOnline" class="text-center mt-4"> <img height="26"
                    alt="Letze gemessene Akku Spannung" src="../../../assets/icons/cloud-lightning.svg"
                    [ngClass]="solarChannelError ? 'led-error-small' : ''">
                <br>
                {{ offlineVoltageText }}
            </div>
        </div>
        <div class="avs-route-station-middle-area">
            <ng-container
                *ngIf="deviceType !== DeviceTypeEnum.MQ && deviceType !== DeviceTypeEnum.LPCam && deviceType !== DeviceTypeEnum.DomeCam && deviceType !== DeviceTypeEnum.BarrierLaneSwitch&& deviceType !== DeviceTypeEnum.BarrierBar && deviceType !== DeviceTypeEnum.BarrierSwing && deviceType !== DeviceTypeEnum.Energy && deviceType !== DeviceTypeEnum.Weather && !hasFuelcellData && deviceType !== DeviceTypeEnum.None; else radar">
                <!-- hab hier entsprechend einbauen :) -->
                <!-- Blinker -->
                <div class="d-flex justify-content-between" *ngIf="lamp">
                    <div class="rounded-5 border"
                        [ngClass]="lampChannelError ? 'border-danger border-2' : 'border-black'">
                        <div *ngIf="isLampActive && isOnline && !lampChannelError; else blinkerDeaktive"
                            class="bg-warning p-3 rounded-5" [@blink]="blinkState">
                        </div>
                        <ng-template #blinkerDeaktive>
                            <div *ngIf="!lampChannelError"
                                class="bg-white p-3 rounded-5"></div>
                            <div *ngIf="lampChannelError"
                                class="bg-white p-3 rounded-5 radar-error"></div>
                        </ng-template>
                    </div>
                    <div class="rounded-5 border"
                        [ngClass]="lampChannelError ? 'border-danger border-2' : 'border-black'">
                        <div *ngIf="isLampActive && isOnline && !lampChannelError; else blinkerDeaktive"
                            class="bg-warning p-3 rounded-5" [@blink]="blinkState">
                        </div>
                        <ng-template #blinkerDeaktive>
                            <div *ngIf="!lampChannelError"
                                class="bg-white p-3 rounded-5"></div>
                        </ng-template>
                    </div>
                </div>
                <!-- Image -->
                <div [ngClass]="imagePanelClass"
                    class="card rounded-0 shadow avs-route-station-panel p-2 position-relative">
                    <!-- TODO: CAMERA avs-route-station-panel beinhaltet höhe und breite // das könnte ich entfernen und ebenfalls dynamisch gestalten -->



                    <!-- TODO: CAMERA Abfrage muss erweitert werden, hier reicht nicht mehr online. hier muss gegen die Cams geprüft werden -->
                    <img #myImage
                        *ngIf="isOnline && isLedOn && ledCode"
                        [src]="environment.apiAddress + getStationImage(ledCode)"
                        alt="Bild wurde nicht gefunden" [mtxTooltip]="tooltipTpl" [mtxTooltipPosition]="'below'"
                        [mtxTooltipClass]="'my-custom-tooltip'" (load)="updateImageDimensions(myImage)"
                        (error)="resetImageDimensions()">
                    <img *ngIf="isLedAnimated" src="assets/icons/shuffle.svg"
                        alt="animatedImage" class="position-absolute bg-white rounded-5 p-1 "
                        style="top: 2px; right: 2px; height: 20px">

                    <!-- Schaltstatus: Auslöser-Icon der letzten Engine-Schaltung (bei MQ-/DI-Auslösern
                         zusätzlich das Symbol des auslösenden Elements), Farbe = Status -->
                    <span *ngIf="getLedEngineResult()"
                        class="avs-engine-status-badge position-absolute {{ getLedEngineClass() }}"
                        style="top: 2px; left: 2px; z-index: 2"
                        [matTooltip]="getLedEngineTooltip()"><img [src]="getLedEngineIcon()"
                            alt="Auslöser"><img *ngIf="getLedEngineSourceIcon()"
                            [src]="getLedEngineSourceIcon()" alt="Auslösendes Element"></span>

                    <div *ngIf="ledChannelError" class="led-error"
                        style="position: absolute; top: 0; bottom: 0; left: 0; right: 0;"></div>
                    <img *ngIf="isOnline && isLedOff"
                        src="assets/led_default.svg"
                        style="height: 184px; width: 112px; position:absolute; top: -22px; left: -7px;">


                    <img *ngIf="isDeviceTypeNone" src="assets/icons/icon_sst_eva.svg"
                        class="bg-white p-1 mt-2">


                    <!-- Cameras -->
                    <img *ngIf="isLpCamDevice"
                        src="assets/icons/camera/icon_kamera_kennzeichen_center.svg">
                    <img *ngIf="isDomeCamDevice"
                        src="assets/icons/camera/icon_kamera_verkehr_center.svg">

                    <!-- Brennstoffzelle     -->
                    <img *ngIf="isDeviceTypeNone && fuelcellChannelError"
                        class="bg-white border border-danger" src="assets/icons/gas_meter.svg">
                    <div
                        *ngIf="isDeviceTypeNone && fuelcellChannelError">
                        <div class="text-danger text-center fw-bold" style="font-size: 14px;">Fehler</div>
                    </div>
                </div>

                <!-- Real Images -->

                <div *ngIf="!isOnline"
                    class="border-bottom border-2 border-black bg-black" style="height: 124px; width: 100px; margin-top: -2px;">
                    <!--  <b class="bg-white">Offline</b>  --></div>
                <div *ngIf="!isOnline && isLedOff"
                    class=""></div>
            </ng-container>
            <ng-template #radar>
                <div *ngIf="hasFuelcellData" class="position-relative">
                    <div class="d-flex justify-content-center  ms-2 me-2 border border-2 border-secondary mt-3 flex-column"
                        [ngClass]="isDoorOpen() ? 'door-open' : ''">

                        <div class="rounded-5" style="height: 10px; width: 10px; position: absolute; bottom: -15px;"
                            [ngClass]="getSystemzustand()"></div>
                        <img *ngIf="!isDoorOpen() && !isFuelSensorAlarmShown" height="70" class="bg-light"
                            src='assets/icons/gas_meter.svg'>
                        <img *ngIf="!isDoorOpen() && isFuelSensorAlarmShown" height="70" class="sensor-active"
                            src='assets/icons/fuel-pump.svg' alt="Meldung externer Tanksensor"
                            title="Meldung externer Tanksensor">



                        <img *ngIf="isLpCamDevice"
                            src="assets/icons/camera/icon_kamera_kennzeichen_center.svg">
                        <img *ngIf="isDomeCamDevice"
                            src="assets/icons/camera/icon_kamera_verkehr_center.svg">
                        <img *ngIf="isDoorOpen()" height="70" src="assets/icons/door-open-fill.svg">
                        <div *ngIf="hasFuelcellData" class="d-flex bg-white">
                            <div [ngClass]="isDoorOpen() ? 'door-open' : ''" class="h-100 w-100">
                                <span class="text-nowrap" style="font-size: 14px;"
                                    [ngClass]="activeCart === 1 ?  'fw-bold' : ''">
                                    {{ fuelLevelCart1}}%</span>
                                |
                                <span class="text-nowrap" style="font-size: 14px;"
                                    [ngClass]="activeCart === 2 ? 'fw-bold': ''">
                                    {{ fuelLevelCart2}}%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Weather -->
                <div *ngIf="deviceType === DeviceTypeEnum.Weather">
                        <div class="d-flex justify-content-center border border-2 border-secondary flex-column bg-warning">
                            <div class="d-flex justify-content-center bg-light" style="max-height:60px;">
                                <img class="bg-light" alt="Icon Wetterstation" src="assets/icons/weather/weather.svg"
                                    matTooltip="{{ weatherDataTime | date: 'dd.MM.yyyy H:mm' }}">
                            </div>
                            <div *ngFor="let weatherDataDisplayValue of weatherDataDisplayValues"
                                class="d-flex justify-content-between align-items-center bg-light p-1"
                                [matTooltip]="weatherDataDisplayValue.label">
                                <div class="bg-light">
                                    <img class="bg-light" [alt]="'Icon ' + weatherDataDisplayValue.label"
                                        [src]="weatherDataDisplayValue.iconPath"
                                        [ngStyle]="{'margin': '3px', 'transform': weatherDataDisplayValue.iconTransform}"></div>
                                <div class="text-nowrap fw-semibold">
                                    {{ weatherDataDisplayValue.value }}</div>
                            </div>
                            <div *ngIf="weatherDataDisplayValues.length === 0"
                                class="text-center text-secondary p-1" style="font-size: 14px;">
                                keine Wetterdaten
                            </div>
                        </div>
                </div>
                <div *ngIf="!hasFuelcellData && deviceType !== DeviceTypeEnum.Weather">
                    <div
                        class="d-flex justify-content-center border border-2 border-secondary ms-2 me-2 mt-4 flex-column bg-light position-relative" style="min-height:120px;">
                        <!-- Schaltstatus der Schranke: Auslöser-Icon der letzten Engine-Schaltung (bei MQ-/DI-
                             Auslösern zusätzlich das Symbol des auslösenden Elements), Farbe = Status -->
                        <span *ngIf="isBarrierDataValid() && getBarrierEngineResult()"
                            class="avs-engine-status-badge position-absolute {{ getBarrierEngineClass() }}"
                            style="top: 2px; left: 2px; z-index: 2"
                            [matTooltip]="getBarrierEngineTooltip()"><img [src]="getBarrierEngineIcon()"
                                alt="Auslöser"><img *ngIf="getBarrierEngineSourceIcon()"
                                [src]="getBarrierEngineSourceIcon()" alt="Auslösendes Element"></span>
                        <img *ngIf="deviceType === DeviceTypeEnum.MQ"
                            height="70" class="bg-light" src="assets/icons/data-end-channel/radar_aq.svg">
                        <div class="d-flex justify-content-center">
                            <img *ngIf="isFirstCamLpCam"
                                height="70" class="bg-light"
                                src="assets/icons/camera/icon_kamera_kennzeichen_center.svg">
                        </div>
                        <div class="d-flex justify-content-center">
                            <img *ngIf="isFirstCamDomeCam"
                                height="70" class="bg-light" src="assets/icons/camera/icon_kamera_verkehr_center.svg">
                        </div>
                        <!--Switch/Bar/Swing -->
                        <div *ngIf="isBarrierDataValid()"
                            class="d-flex justify-content-center">
                            <img class="bg-light" [src]="getIconForBarrierPositioningStatus()">  <!--[@blink]="getBarrierPositioningBlinkStatus()"-->
                        </div>
                        <!--Energy -->
                        <div *ngIf="deviceType === DeviceTypeEnum.Energy"
                             class="d-flex justify-content-center">
                            <img class="bg-light" src="assets/icons/dynabank.svg">
                        </div>
                       <img *ngIf="isDeviceTypeNone" height="70"
                            src="assets/icons/icon_sst_eva.svg" class="d-flex bg-light" style="padding: 5px">
                    </div>
                    <div *ngIf="isBarrierDataValid()"
                            class="d-flex justify-content-center">
                        <div class="d-flex justify-content-between">
                            <div class="p-2 rounded-3">
                                <div *ngIf="isBarrierBlocked() == undefined"
                                    class="p-2 rounded-3" style="background: darkgrey">
                                </div>
                                <div *ngIf="isBarrierBlocked() == true"
                                    class="p-2 rounded-3" style="background: red">
                                </div>
                                <div *ngIf="isBarrierBlocked() == false"
                                    class="p-2 rounded-3" style="background: green;" > 
                                </div>
                            </div>
                            <div class="p-2">
                                <div *ngIf="isBarrierWarmUp() == true"
                                    class="p-2 rounded-3" style="background: orange">
                                </div>
                                <div *ngIf="isBarrierWarmUp() != true"
                                    class="p-2 rounded-3" style="background: darkgrey">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
        <div class="avs-route-station-site-area">
            <div *ngIf="routeStation?.schemaInfo" class="d-flex justify-content-center mb-2 position-relative">
                <img *ngIf="simSignal !== 0"
                    [matTooltip]="simProvider"
                    matTooltipPosition="above" height="26" alt="Signal Icon nach Empfangsstärke"
                    [src]="getReceptionIcon()">
            </div>
            <ng-container *ngFor="let radar of radars">
                <div *ngIf="isModalOpen" class="d-flex justify-content-center icon-button"
                    (click)="openRadarDataChart()">
                    <img *ngIf="!radar.cInfo.channel.isInChannelError" height="26" alt="Radar Icon"
                        src="assets/icons/data-end-channel/radar.svg"> <span *ngIf="!radar.cInfo.channel.isInChannelError"
                        class="text-secondary " style="font-size: 12px"> {{radar.cInfo.channel.de}}</span>
                    <img *ngIf="radar.cInfo.channel.isInChannelError" height="26" alt="Radar Icon" class="radar-error"
                        src="assets/icons/data-end-channel/radar.svg"> <span *ngIf="radar.cInfo.channel.isInChannelError"
                        class="text-secondary " style="font-size: 12px"> {{radar.cInfo.channel.de}} </span>
                </div>
                <div *ngIf="!isModalOpen" class="d-flex justify-content-center">
                    <img *ngIf="!radar.cInfo.channel.isInChannelError" height="26" alt="Radar Icon"
                        src="assets/icons/data-end-channel/radar.svg"> <span *ngIf="!radar.cInfo.channel.isInChannelError"
                        class="text-secondary " style="font-size: 12px"> {{radar.cInfo.channel.de}}</span>
                    <img *ngIf="radar.cInfo.channel.isInChannelError" height="26" alt="Radar Icon" class="radar-error"
                        src="assets/icons/data-end-channel/radar.svg"> <span *ngIf="radar.cInfo.channel.isInChannelError"
                        class="text-secondary " style="font-size: 12px"> {{radar.cInfo.channel.de}}</span>
                </div>
                <div class="text-secondary ms-3 small text-nowrap text-center" style="margin-top: -5px">
                    {{radar.data?.allSmoothedAverageSpeed}}
                    km/h
                </div>
            </ng-container>

        </div>
    </div>
    <div *ngIf="!isOnline" class="position-absolute avs-offline-station" matTooltip='{{
        lastDataTime | date : "dd.MM.YYYY H:mm" }}' matTooltipPosition="above"></div>
</div>


<ng-template #tooltipTpl class="my-custom-tooltip">
    <div class="my-custom-tooltip">
        <img [src]="environment.apiAddress + getStationImage(ledCode)" alt=""
            style="z-index: 9999; width: 190px; height: auto;">
    </div>

</ng-template>
